<template>
<div class="row justify-content-center align-content-center">
  <div class="card m-2" style="width: 18rem; border-radius: 20px; box-shadow: 10px 10px 20px grey">
      <img src="../assets/inicio.jpg" class="card-img-top" alt="software login" style="border-radius: 20px 20px 0px 0px">
      <div class="card-body">
        <p class="card-text texto_base2">Acceso al software mediante un usuario y clave</p>
      </div>
  </div>

  <div class="card m-2" style="width: 18rem; border-radius: 20px; box-shadow: 10px 10px 20px grey">
      <img src="../assets/menu.jpg" class="card-img-top" alt="software menu" style="border-radius: 20px 20px 0px 0px">
      <div class="card-body">
        <p class="card-text texto_base2">Un vez verificado el usuario, acceso al menu principal</p>
      </div>
  </div>

  <div class="card m-2" style="width: 18rem; border-radius: 20px; box-shadow: 10px 10px 20px grey">
      <img src="../assets/paneles.jpg" class="card-img-top" alt="software java" style="border-radius: 20px 20px 0px 0px">
      <div class="card-body">
        <p class="card-text texto_base2">Paneles con distintas funcionalidades: CRUD de la BBDD, informes, etc.</p>
      </div>
  </div>
</div>
</template>

<script>
export default {
    name:'Programador',

}
</script>

<style>

</style>